import React, { useEffect } from "react";
import { useLocalization } from "gatsby-theme-i18n";
import { useSelector } from "react-redux";
import LocaleSelectorComponent from "../../components/locale-selector";
import { setLanguageLocalStorage, getBaseLocale } from "../../utils";
import api from "../../api";

const LocaleSelector = ({ isAuthenticated }) => {
  const { locale, defaultLang, localizedPath } = useLocalization();
  const userId = useSelector((state) => state.user.data.id);
  const isAdmin = useSelector((state) => state.user.data.isAdmin);

  const handleChangeLocale = async (evt) => {
    const newLocale = evt.target.value;
    if (userId) {
      if (isAdmin) {
        await api.adminUpdateUserLocale(userId, getBaseLocale(newLocale));
      } else {
        await api.patchLoggedUser({ locale: getBaseLocale(newLocale) });
      }
    }

    setLanguageLocalStorage(newLocale);
    const pathname = window.location.pathname.replace(`${locale}/`, "");
    const { search } = window.location;

    if (defaultLang === newLocale) {
      window.location.href = `${pathname}${search}`;
    } else {
      window.location.href = localizedPath({ locale: newLocale, path: `${pathname}${search}` });
    }
  };

  useEffect(() => {
    setLanguageLocalStorage(locale);
  }, []);

  return (
    <LocaleSelectorComponent
      isAdmin={isAdmin}
      isAuthenticated={isAuthenticated}
      onChangeLocale={handleChangeLocale}
      currentLocale={locale}
    />
  );
};

export default LocaleSelector;
